import ELK from "elkjs/lib/elk.bundled.js";
import type { Connection, System } from "../types/chain";
import type { XY } from "../store/layoutStore";

const NODE_W = 200;
const NODE_H = 70;

const elk = new ELK();

const ELK_OPTIONS = {
  "elk.algorithm": "mrtree",
  "elk.direction": "RIGHT",
  "elk.spacing.nodeNode": "40",
};

export async function computeElkLayout(
  systems: System[],
  connections: Connection[],
): Promise<Record<string, XY>> {
  const graph = {
    id: "root",
    layoutOptions: ELK_OPTIONS,
    children: systems.map((s) => ({ id: s.id, width: NODE_W, height: NODE_H })),
    edges: connections.map((c) => ({
      id: c.id,
      sources: [c.from],
      targets: [c.to],
    })),
  };
  const result = await elk.layout(graph);
  const positions: Record<string, XY> = {};
  result.children?.forEach((c) => {
    if (c.x !== undefined && c.y !== undefined) {
      positions[c.id] = { x: c.x, y: c.y };
    }
  });
  return positions;
}
